import controller from './vd-feedback.controller'
import template from './vd-feedback.html'

/**
 * A feedback request that can be inserted anywhere in the page.
 *
 * @role alert
 */
export default {
  bindings: {
    activity: '@',
    forceUnseenActivitySample: '<?',
    question: '@',
    promptPositive: '@',
    promptNegative: '@',
    hideBanner: '<?',
  },
  controller,
  require: {
    vdBannerCtrl: '?^vdBanner',
  },
  template,
  transclude: true,
}
